import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TrendencyUtilsService } from '@trendency/utils';
import { RouteMapService } from '../../services/route-map.service';
import { BaseComponent } from '../base.component';

declare let $: any;

@Component({
  selector: 'app-trip-cards',
  templateUrl: './trip-cards.component.html',
  styleUrls: ['./trip-cards.component.scss'],
})
export class TripCardsComponent extends BaseComponent implements AfterViewInit, OnInit {
  @ViewChild('tripCarouselElement', { static: true }) tripCarouselElement: ElementRef;
  cards: any[];

  constructor(private readonly routeMap: RouteMapService, private readonly utilsService: TrendencyUtilsService) {
    super();
  }

  ngOnInit(): void {
    this.cards = this.componentObject.subComponents.map((card: any) => {
      const sc = card?.subComponents?.length && card?.subComponents[0];
      return {
        ...card,
        customUrl: sc.customUrl,
        routerLink: sc.contentType ? this.routeMap.getRoute(sc) : null,
        newTab: sc.newTab,
      };
    });
  }

  ngAfterViewInit(): void {
    if (this.utilsService.isBrowser()) {
      this.initSlick();
    }
  }

  initSlick(): void {
    $(this.tripCarouselElement.nativeElement).slick({
      dots: false,
      autoplay: false,
      lazyLoad: 'ondemand',
      centerMode: false,
      slidesToShow: 4,
      speed: 200,
      autoplaySpeed: 3000,
      variableWidth: true,
      arrows: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: false,
            slidesToShow: 1,
            infinite: true,
          },
        },
      ],
    });
  }
}
